// Simple in-memory focus manager to coordinate which component should receive post-action focus.
// This avoids focus fights between components by letting a component declare itself "active"
// before an action and only that component will attempt to restore focus afterwards.

let activeId = null;

export function setActive(id) {
  activeId = id;
}

export function getActive() {
  return activeId;
}

export function clearActive() {
  activeId = null;
}
